import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  icon: {
    height: '.8rem',
    marginRight: theme.spacing(3),
  },
}));

export default useStyles;
